import { render, staticRenderFns } from "./PoiSubLift.vue?vue&type=template&id=12a27d52"
import script from "./PoiSubLift.js?vue&type=script&lang=js&external"
export * from "./PoiSubLift.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports